<!--
 * @Description: 教学场地单条查找带回
 * @Author: PF
 * @Date: 2023-02-03 15:00:22
 * @LastEditors: PF
 * @LastEditTime: 2024-10-09 16:56:10
-->
<template>
  <div class="jzg_insert">
    <el-dialog style="min-width: 770px;" class="wp70 hp70" :model-value="openDanTiao" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">教学场地</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDanTiao', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>

      <el-container>
        <el-header class="pl0 pr0">
          <!-- 搜索区域 BEGIN -->
          <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
            <el-form-item>
              <el-input placeholder="教室名称" class="filter-item" v-model="dataGrid.parms.jsmc" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                <template #suffix>
                  <el-icon class="el-input__icon pointer" @click="bindTable()"><search /></el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="校区" v-model="dataGrid.parms.xqid" clearable filterable  @change="bindTable()">
                <el-option v-for="item in xqData" :key="item.id" :label="item.xqmc" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="建筑物名称" v-model="dataGrid.parms.jzwid" clearable filterable  @change="bindTable()">
                <el-option v-for="item in jzwData" :key="item.id" :label="item.jzwmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-form>
          <!-- 搜索区域 END -->
        </el-header>
        <el-main class="pl0 pb0 pr0">
          <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column label="序号" type="index" width="80" fixed align="center" />
            <el-table-column label="教室编号" prop="jsbh" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="教室名称" prop="jsmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="校区" prop="xqmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <!-- <el-table-column label="机构" prop="jgmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/> -->
            <el-table-column label="建筑物" prop="jzwmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="教室类型" prop="jslxmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="90" fixed="right" align="center">
              <template #default="scope">
                <el-button type="primary" @click="savestudent(currentRow=scope.row)">选择</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
      </el-container>
      <template #footer>
        <div class="dialog-footer">
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDanTiao', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, watch } from 'vue'
import { loadList, loadSelect, closeWindow } from '@/api/common.js'
import pagination from '@/components/pagination.vue'
const props = defineProps({
  openDanTiao: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDanTiao', 'ReturnData'])

const currentRow = ref()
const savestudent = () => {
  emits('ReturnData', currentRow.value)
  handleClose()
}
const handleClose = () => {
  emits('update:openDanTiao', false)
}
const xqData = ref()
loadSelect({
  url: '/api/v2/pdp/xiaoqu/list',
  data: xqData,
  order: 'xqdm',
  sort: 'asc'
})
const jzwData = ref()
loadSelect({
  url: '/api/v2/zichan/jianzhuwu/list',
  data: jzwData,
  order: 'jzwmc',
  sort: 'asc'
})
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {
    pagerCount: 5,
    layout: 'prev, pager, next, total'
  },
  loading: false,
  orderBy: { prop: 'jsbh', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/zichan/jiaoxuechangdi/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}
watch(
  () => props.openDanTiao,
  () => {
    if (props.openDanTiao) {
      bindTable()
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
</style>
